export enum ResourceManagerEvent {
    SUBMIT = 'submit_resource',
}
